import { gql } from '__generated__';

export const ParticipantFieldEntryFieldsFragment = gql(`
  fragment BackendParticipantFieldEntryFields on ParticipantFieldEntry {
    id
    field {
      id
    }
    value
    choice_entries {
      id
      choice {
        id
        title
        position
        enabled
      }
    }
  }
`);

export const ParticipantFieldFieldsFragment = gql(`
  fragment BackendParticipantFieldFields on ParticipantField {
    id
    title
    description
    type
    scope
    required_participant_attributes
    required_promotions {
      id
    }
    choices {
      id
      title
      position
      enabled
    }
    required
    config
    has_external_validation
    enabled
  }
`);

export const RegistrationFieldsFragment = gql(`
  fragment BackendRegistrationFields on Registration {
    id
    created_at
    assigned
    invited_email
    complete
    corral_name
    sequence
    required_attributes
    first_name
    last_name
    full_name
    date_of_birth
    gender
    nationality
    street
    house_number
    zip_code
    city
    extra_address_line
    country
    phone
    emergency_phone
    status
    allowed_statuses
    waitlist_position
    resale {
      id
      public
      public_url
    }
    preregistration {
      id
      lottery_status
      lottery_start_date
      lottery_end_date
    }
    participant_fields(include_inactive: true) {
      ...BackendParticipantFieldFields
    }
    participant_field_entries(include_inactive: true) {
      ...BackendParticipantFieldEntryFields
    }
    event {
      id
      has_ticket_numbers
      has_lotteries
      allow_teams
    }
    ticket_url
    ticket {
      id
      title
      allow_join_team
      allow_create_team
      team_type {
        id
        title
      }
      has_time_slots
    }
    ticket_number
    ticket_number_locked
    ticket_number_digits
    ticket_number_sequence {
      id
      corral_name
      start_time
    }
    time_slot {
      id
      title
      start_date
      start_time
      multi_date
    }
    participant {
      id
      full_name
      email
      active
    }
    resold_to {
      id
      sequence
      owner {
        id
        full_name
      }
    }
    resold_by {
      id
      sequence
      owner {
        id
        full_name
      }
    }
    waitlist_invites {
      id
      status
      created_at
      pending_invite {
        id
        expires_at
      }
      resale_registration {
        id
        sequence
        owner {
          id
          full_name
        }
      }
    }
    waitlist_invitees {
      id
      status
      created_at
      pending_invite {
        id
        expires_at
      }
      waitlist_registration {
        id
        sequence
        owner {
          id
          full_name
        }
      }
    }
    lottery {
      id
      title
    }
    rejected_lotteries {
      id
      title
    }
    preregistered_for {
      id
      sequence
      full_name
      participant {
        id
      }
      ticket {
        id
        title
      }
    }
    preregistered_by {
      id
      sequence
      full_name
      participant {
        id
      }
      ticket {
        id
        title
      }
      lottery {
        id
        title
      }
    }
    purchase {
      id
      batch_size
      unit_id
      active
      order {
        id
        invoice_id
        amount
        participant {
          id
          full_name
        }
      }
      promotion {
        id
        title
      }
      invitation_code {
        id
        value
      }
    }
    upgrades(include_inactive: true) {
      id
      product {
        id
        title
      }
      purchase {
        id
        batch_size
        active
        promotion {
          id
          title
        }
        order {
          id
          invoice_id
          participant {
            id
          }
        }
      }
      product_variant {
        id
        title
      }
      participant_fields(include_inactive: true) {
        ...BackendParticipantFieldFields
      }
      participant_field_entries(include_inactive: true) {
        ...BackendParticipantFieldEntryFields
      }
    }
    team {
      id
      title
      team_type {
        id
      }
    }
    scans {
      id
      scanner {
        id
        title
      }
      scanned_at
    }
    charity {
      id
      title
    }
    fundraising_campaign {
      id
      url
    }
  }
`);

export default gql(`
  query GetRegistrationSummary($participant_id: ID!, $event_id: ID!, $limit: Int, $filters: RegistrationFilters) {
    registrationSummary(event: $event_id, participant: $participant_id, include_inactive: true) {
      id
      registrations_count
      filtered_registrations_count: registrations_count(filters: $filters)
      assigned_registrations_count: registrations_count(filters: { assigned: true })
      unassigned_registrations_count: registrations_count(filters: { assigned: false })
      registrations(filters: $filters, limit: $limit) {
        ...BackendRegistrationFields
      }
      tickets {
        id
        title
      }
      teams {
        id
        title
      }
    }
  }
`);
